export default "__VITE_ASSET__d77c4908__"